
<pq-userpass [profile]="profile" [redirectLocation]="redirectLocation" *ngIf="multipleMatchingAccount.length === 0"></pq-userpass>

<pq-institution [profile]="profile" [redirectLocation]="redirectLocation" [multipleMatchingAccount]="multipleMatchingAccount" [accountId]="accountId" *ngIf="multipleMatchingAccount.length > 0"></pq-institution>

